function Kpi({ label, value, tone, testid }) {
  return (
    <div className="cc-card px-4 py-3" data-testid={testid}>
      <p className="text-[10px] font-semibold uppercase tracking-wide text-slate-400">{label}</p>
      <p className={`text-2xl font-bold font-display tnum ${tone || "text-slate-800"}`}>{value}</p>
    </div>
  );
}

export default function AdvertiserOverview({ data, onOpenZone }) {
  if (!data) return <div className="h-40 cc-card animate-pulse" />;
  const zones = data.markets.flatMap((m) => m.zones.filter((z) => z.status === "active").map((z) => ({ ...z, market: m.name })));
  return (
    <div className="space-y-5" data-testid="advertiser-overview">
      <div className="grid gap-3 grid-cols-2 md:grid-cols-4 lg:grid-cols-8">
        <Kpi label="Active advertisers" value={data.total_active_advertisers} testid="ov-active" />
        {["7", "14", "30", "60", "90"].map((d) => <Kpi key={d} label={`Expiring ≤${d}d`} value={data.expiring[d]} tone={d <= 14 ? "text-orange-700" : "text-slate-800"} testid={`ov-exp-${d}`} />)}
        <Kpi label="Renewals due" value={data.renewals_due} tone="text-amber-700" testid="ov-due" />
        <Kpi label="Expired – action" value={data.expired} tone="text-red-600" testid="ov-expired" />
      </div>
      <div className="grid gap-5 lg:grid-cols-3">
        <div className="cc-card p-4 lg:col-span-2">
          <h3 className="font-display font-semibold text-slate-800 mb-2">Zone capacity</h3>
          <div className="overflow-x-auto">
            <table className="w-full text-sm">
              <thead><tr className="text-left text-[11px] uppercase tracking-wide text-slate-400"><th className="py-1.5">Market › Zone</th><th>Advertisers</th><th>Used</th><th>Available</th><th>Renewals</th><th>Ending ≤30d</th></tr></thead>
              <tbody>{zones.map((z) => (
                <tr key={z.id} className="border-t border-slate-100 hover:bg-slate-50 cursor-pointer" onClick={() => onOpenZone(z)} data-testid={`ov-zone-${z.id}`}>
                  <td className="py-1.5"><span className="text-slate-400">{z.market} ›</span> <span className="font-medium">{z.name}</span></td>
                  <td className="tnum">{z.advertisers}</td><td className="tnum">{z.used_positions}/{z.capacity}</td>
                  <td className={`tnum font-semibold ${z.available_positions <= 0 ? "text-red-600" : "text-[#4A700A]"}`}>{z.available_positions}</td>
                  <td className="tnum">{z.renewals_upcoming}</td><td className="tnum">{z.ending_soon}</td>
                </tr>))}</tbody>
            </table>
          </div>
        </div>
        <div className="space-y-5">
          <div className="cc-card p-4">
            <h3 className="font-display font-semibold text-slate-800 mb-2">Active by market</h3>
            {data.markets.filter((m) => m.advertisers).map((m) => <div key={m.id} className="flex justify-between py-1 text-sm"><span>{m.name}</span><span className="tnum font-semibold">{m.advertisers}</span></div>)}
            {!data.markets.some((m) => m.advertisers) && <p className="text-sm text-slate-400">No active placements yet.</p>}
          </div>
          <div className="cc-card p-4" data-testid="ov-salespeople">
            <h3 className="font-display font-semibold text-slate-800 mb-2">Advertisers by salesperson</h3>
            {data.by_salesperson.map((s) => <div key={s.name} className="flex justify-between py-1 text-sm"><span>{s.name}</span><span className="tnum font-semibold">{s.advertisers}</span></div>)}
            {!data.by_salesperson.length && <p className="text-sm text-slate-400">—</p>}
          </div>
        </div>
      </div>
    </div>
  );
}
